/* eslint-disable max-len */
// import logo from '../../../../shared/img/logo/logo_MW.png';
// import instaLogo from '../../../../shared/img/logo/insta_logo.png';

import { formatMinutes } from '../../../../helpers/utils';

// Hauteur max utilisable pour la liste de modules (dépend du layout de la slide)
// Ex: LAYOUT_16x9 = 5.63" de haut, LAYOUT_4x3 = 7.5"
const SLIDE_MAX_Y = 5.2; // laisse une marge en bas, ajuste selon ton layout

const renderModuleList = (slideProgram, pptx, modules, x, startY) => {
  if (modules && modules.length > 0) {
    const available = SLIDE_MAX_Y - startY;
    const idealRowHeight = 0.40;
    const idealFontSize = 15;

    // Hauteur de ligne réelle : ne dépasse jamais l'idéal, mais se réduit si trop de modules
    const rowHeight = Math.min(idealRowHeight, available / modules.length);

    // La police suit la même logique de réduction, avec un plancher lisible (8pt)
    const fontSize = Math.max(
      8,
      Math.min(idealFontSize, idealFontSize * (rowHeight / idealRowHeight)),
    );

    // La puce suit aussi, plus discrètement
    const bulletSize = Math.max(0.03, 0.05 * (rowHeight / idealRowHeight));

    let y = startY;
    modules?.forEach((module) => {
      slideProgram.addShape(pptx.ShapeType.ellipse, {
        fill: { type: 'solid', color: '696969' },
        x,
        y: y + rowHeight / 2,
        w: bulletSize,
        h: bulletSize,
      });

      slideProgram.addText(module.name, {
        x: x + 0.25,
        y,
        w: 4,
        h: rowHeight,
        align: 'left',
        fontSize,
        color: '696969',
        bold: true,
      });

      y += rowHeight;
    });
  }
};

const addSlideProgram = (pptx, addBrandingToSlide, year, index, schoolType) => {
  // presentation slide
  const slideProgram = pptx.addSlide({ masterName: 'COMPANY_BRANDING' });
  slideProgram.addText(`PROGRAMME ANNEE ${index + 1} ${schoolType === 'IFSI' && index + 1 === 1 ? '- Référentiel 2026' : '- Référentiel 2009'}`, {
    x: 1.25,
    y: 0.25,
    w: 8,
    h: 0.5,
    align: 'center',
    fontSize: 22,
    color: '4f4f4f',
    bold: true,
    shape: pptx.ShapeType.rect,
    fill: { color: 'fae3f2' },
    line: {
      color: 'f71616',
      width: 1,
    },
  });

  // Semestres impairs
  slideProgram.addText(`Semestre ${year[0].semester} ${year[0].adminData
    ? `- ${formatMinutes(year[0].adminData?.elearningHours)} (E-learning) ${year[0].adminData?.presentialHours
      ? `+ ${formatMinutes(year[0].adminData?.presentialHours)} (cours)`
      : ''}`
    : ''}`, {
    x: 0.5,
    y: 1.5,
    w: 5,
    h: 0.5,
    align: 'left',
    fontSize: 16,
    color: 'fc1e1e',
    bold: true,
  });

  renderModuleList(
    slideProgram,
    pptx,
    year && year[0].courses && year[0]?.courses[0]?.filledModules ? year[0].courses[0].filledModules : [],
    0.5,
    2,
  );

  if (year[1]) {
    // Semestres pairs
    slideProgram.addText(`Semestre ${year[1].semester} ${year[1].adminData
      ? `- ${formatMinutes(year[1].adminData?.elearningHours)} (E-learning) ${year[1].adminData?.presentialHours
        ? `+ ${formatMinutes(year[1].adminData?.presentialHours)} (cours)`
        : ''}`
      : ''}`, {
      x: 5.5,
      y: 1.5,
      w: 4,
      h: 0.5,
      align: 'left',
      fontSize: 16,
      color: 'fc1e1e',
      bold: true,
    });

    renderModuleList(
      slideProgram,
      pptx,
      year && year[1].courses && year[1]?.courses[0]?.filledModules ? year[1].courses[0].filledModules : [],
      5.5,
      2,
    );
  }

  addBrandingToSlide(pptx, slideProgram);
};

export default addSlideProgram;
